import { render, staticRenderFns } from "./renewlist.vue?vue&type=template&id=71232dd1&scoped=true"
import script from "./renewlist.vue?vue&type=script&lang=js"
export * from "./renewlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71232dd1",
  null
  
)

export default component.exports